module.exports = __webpack_public_path__ + "aa13426852335ac7102bfe1d42f2188f.jpg";